import React, {Component, useState,useEffect} from 'react';
import Firebase from 'firebase/app';
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/database'

//const serviceAccount = require("/Users/yonyfernandez/student-glance2.0-adminKey.json");
class Network {
    // properties
    private fireAuth: any;
    private realtimeDB: any;
    private firestoreDB: any;
    private provider: any;
    public user: string | any;

    // functions
    constructor(){
        this.fireAuth    = Firebase.auth();
        this.realtimeDB  = Firebase.database();
        this.firestoreDB = Firebase.firestore();
        this.provider = new Firebase.auth.GoogleAuthProvider();

        this.getUserID = this.getUserID.bind(this);
        this.authID = this.authID.bind(this);
        this.getAllDocsFromCol = this.getAllDocsFromCol.bind(this);
    }

    // just return the userID promise Object do not pass the value of it.
    // this way on the client side we can get the value over there properly
    googleAuth(token: any = undefined) {
        let userID: any;
        let provider = this.provider;
        let checkUser = Firebase.auth().currentUser;
        provider.setCustomParameters({
            'hd': 'manhattan.edu',
            'prompt': 'select_account'
        });
        if (token) {
            // console.log(token);
            let credential = Firebase.auth.GoogleAuthProvider.credential(token);
           let userID = this.fireAuth.signInWithCredential(credential).then((cred:any) => {
               let userObj = {...cred.user, token};
               // console.log(userObj);
                return(userObj)
            }).catch((error: any) => {
                // console.log(error)
            })

        } else {
            /*Checking to see if auth issue is being cause by user still being logged in*/
            // @ts-ignore
            if (checkUser) {
                // Checking to see if the user is logged in for some reason
                // console.log("logined:" + checkUser);

                Firebase.auth().signOut().then(() => {
                // Logging user out
                }).catch((error) => {
                    let errorCode = error.code;
                    let errorMessage = error.message;

                    // console.log(errorCode);
                    // console.log(errorMessage);
                });

            } else {
             // console.log("not loggedin")

                // @ts-ignore
                userID = this.fireAuth.signInWithPopup(provider).then(this.authID).catch(function (error) {
                    // Handle Errors here.

                    let errorCode = error.code;
                    let errorMessage = error.message;
                    let email = error.email;
                    let credential = error.credential;
                    // console.log(error)
                });

                return userID ;

            }

        }

    }

    authID(result: any): string {

        let token = result.credential.idToken;
        let user = result.user;

        // console.log(token);
        // console.log(user.uid);
        //setting userID
        this.user = user.uid;
        let userObj = {...user, token};


        if (this.user != null){
            // console.log("not null");
            return({...result.user, token});
        }else{
            // console.log("Null");

            return "null"
        }
    }

    getUserID(){
        return this.user
    }

    signOut(){
        Firebase.auth().signOut().then(function() {

        }).catch(function(error) {
            let errorCode = error.code;
            let errorMessage = error.message;

        });
    }

    /*
   @param userID        :: user ID
   @param startColPath  :: starting collection
   @param endColPath    :: end collection found within the userID
   @param colPath       :: collection paths that do not reuquire authentication access

    @returns ::
   Description ::
   * - to pull data from Users
            - requires :: userID, userStartPath, userEndPath
              Example ::
                          users/v3oup7TheXU6XjSIIob3bQgKtV93/Courses/

     - can pull data from other collections
            - requires :: colPath
              Example ::
                           Calendar/AllEvents/Today/
        */
    getAllDocsFromCol(colPath: string = "", userID: string = "" , userStartPath: string = "", userEndPath: string = ""): any{
        return new Promise((resolve, reject)=>{
            let data: any;
            let documentObject: any;
            let fsDB = this.firestoreDB;

            switch(userID){
                case "" :
                    fsDB.collection(colPath).get().then((querySnapshot: any) => {
                        querySnapshot.forEach((doc: any) => {
                        });
                        if (querySnapshot !== null ){
                            resolve(querySnapshot);
                        }else{
                            reject("SOMETHING BAD HAPPENED");
                        }
                    });
                    break;
                default:
                    let path = userStartPath + userID + userEndPath;

                    fsDB.collection(path).get().then((querySnapshot: any) => {
                        querySnapshot.forEach((doc: any) => {
                        });
                        if (querySnapshot !== null ){
                            resolve(querySnapshot);
                        }else{
                            reject("SOMETHING BAD HAPPENED");
                        }
                    })
            }
        })
    }
}
export default Network;